<app-preloader></app-preloader>
    <router-outlet></router-outlet>
<app-footer></app-footer>